import request from "../../utils/request";
import { CompanyCurrencyRate, CompanyCurrencyRateInput, Country, Currency, Result, TimeZoneInfoView, UserCurrency } from "../../models/general";

export async function GetCurrencies() {
    const response = await request.get<Result<Currency[]>>("Currency/GetCurrencies");
    return response.data;
}
export async function GetCompanyRates() {
    const response = await request.get<Result<CompanyCurrencyRate[]>>(`Currency/GetCompanyRates`);
    return response.data;
}
export async function AddCompanyRate(input: CompanyCurrencyRateInput) {
    const response = await request.post<Result<boolean>>("Currency/AddCompanyRate", input);
    return response.data;
}
export async function EditCompanyRate(id: number, input: CompanyCurrencyRateInput) {
    const response = await request.post<Result<boolean>>(`Currency/EditCompanyRate/${id}`, input);
    return response.data;
}
export async function EditCompanyBaseCurrency(id: number) {
    const response = await request.post<Result<boolean>>(
        `Currency/EditCompanyBaseCurrency`,
        id,
        { headers: { 'Content-Type': 'application/json' } }
    );
    return response.data;
}

export async function EditUserCurrencyAndRule(userId: string, userCurrencyRule: UserCurrency, currencyId: number) {
    const response = await request.post<Result<boolean>>(`Currency/EditUserCurrencyAndRule/${userId}/${currencyId}`,
        userCurrencyRule, 
        { headers: { 'Content-Type': 'application/json' } });
    return response.data;
}

export async function RemoveCompanyRate(id: number) {
    const response = await request.post<Result<boolean>>(`Currency/DeleteCompanyRate/${id}`);
    return response.data;
}

